import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useLocalePath } from "@/hooks/useLocalePath";

const NotFound = () => {
  const location = useLocation();
  const { lp } = useLocalePath();

  useEffect(() => {
    console.error("خطای ۴۰۴: تلاش کاربر برای دسترسی به مسیر ناموجود:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 text-center font-['Vazirmatn']">
      <div className="space-y-4">
        <h1 className="text-8xl font-bold text-primary font-['Orbitron']">۴۰۴</h1>
        <h2 className="text-2xl font-bold text-foreground">صفحه مورد نظر پیدا نشد</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          متاسفانه صفحه‌ای که به دنبال آن هستید وجود ندارد یا حذف شده است.
        </p>
        <div className="pt-4">
          <Button asChild className="gap-2">
            <Link to={lp('/')}>
              <Home className="w-4 h-4" />
              بازگشت به صفحه اصلی
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
